import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { useDict } from '../../../contexts/LanguageContext';
import ROUTE_NAME from '../../../routes/RouteName';
import FaqContainer from './FaqContainer';

const InvestNow = () => {
    const dict = useDict();

    return (
        <FaqContainer
            navigationActive="investnow"
            prevLink={ROUTE_NAME.FAQ_REGISTRATION_PROCESS}
            prevTitle={dict.registrationProcess}
            nextLink={ROUTE_NAME.FAQ_TYPES_OF_INVESTMENT_NOTES}
            nextTitle={dict.typesOfInvestmentNotes}
        >
            <Card className="card--not-full-height">
                <CardBody className="documentation__card-body">
                    <div className="card__title">
                        <h3 className="bold-text" style={{ color: '#264391' }}>
                            {dict.financingPlatform}
                        </h3>
                    </div>
                    <div className="card__title">
                        <h4 className="bold-text" style={{ color: '#264391' }}>
                            {dict.investNowFaq}
                        </h4>
                    </div>
                    <p>
                        <strong>
                            {dict.investNowFaqTitle1}
                        </strong>
                    </p>
                    <p>
                        {dict.investNowFaqTitle1Text1}
                    </p>
                    <p>
                        <strong>
                            {dict.investNowFaqTitle2}
                        </strong>
                    </p>
                    <p>
                        {dict.investNowFaqTitle2Text1}
                    </p>
                    <p>
                        {dict.investNowFaqTitle2Text2}
                    </p>
                    <ol>
                        <li>{dict.investNowFaqTitle2Text2List1}</li>
                        <li>{dict.investNowFaqTitle2Text2List2}</li>
                        <li>{dict.investNowFaqTitle2Text2List3}</li>
                        <li>{dict.investNowFaqTitle2Text2List4}</li>
                        <li>{dict.investNowFaqTitle2Text2List5}</li>
                        <li>{dict.investNowFaqTitle2Text2List6}</li>
                        <li>{dict.investNowFaqTitle2Text2List7}</li>
                    </ol>
                    <p>
                        {dict.investNowFaqTitle2Text3}
                    </p>
                    <p>
                        <strong>
                            {dict.investNowFaqTitle3}
                        </strong>
                    </p>
                    <p>
                        {dict.investNowFaqTitle3Text1}
                    </p>
                    <p>
                        {dict.investNowFaqTitle3Text2}
                    </p>
                </CardBody>
            </Card>
        </FaqContainer>
    );
};

export default InvestNow;
